import { useRouter } from "next/router";
import type React from "react";
import { PATH as STAFFS_PATH } from "~/pages/settings/staffs";

export const Page: React.FC = () => {
	const router = useRouter();
	if (router.isReady) {
		router.replace(STAFFS_PATH).then();
	}
	return <></>;
};
